<template>
    <div class="container">
        <div>
            <router-link to="/themes/create">+ Создать</router-link>
        </div>
        <table class="table">
            <thead>
            <tr>
                <th>#</th>
                <th>Название</th>
                <th>Уровень</th>
                <th>Описание</th>
                <th>Уроки</th>
                <th>Статус</th>
                <th>Edit</th>
                <th>Delete</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="theme in getAllThemes">
                <td>{{ theme.id }}</td>
                <td>{{ theme.name }}</td>
                <td>{{ theme.level }}</td>
                <td>{{ theme.description }}</td>
                <td>{{ theme.lessons_amount }}</td>
                <td>{{ theme.status ? 'Опубликовано' : 'Черновик' }}</td>
                <router-link :to="`/themes/edit/${theme.id}`">
                    <button>Редактировать</button>
                </router-link>
                <td>
                    <button @click="remove(theme.id)">Delete</button>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {

    name: "ThemesPage",
    computed: {
        ...mapGetters({
            "getAllThemes": 'themes/getAllThemes',
        })
    },
    methods: {
        remove(id) {
            this.deleteTheme(id)
            this.getThemes();
        },
        ...mapActions({
            'getThemes': 'themes/getThemes',
            "deleteTheme": 'themes/deleteTheme',
        }),
    },
    mounted() {
        this.getThemes();
    }
}
</script>

<style scoped>

</style>